// extracted by mini-css-extract-plugin
export var closeButton = "_jg-1";
export var closeX = "_jg-3";
export var container = "_jg-0";
export var image = "_jg-2";